<mat-slide-toggle
  class="toogle-auto-load"
  color="warning"
  [(ngModel)]="isAutoLoadCheckedLocal"
  (change)="toggleAutoLoad()"
  matTooltip="Auto refresh data to see live status of migration"
  labelPosition="before"
>
  <span>Auto load&nbsp;</span>
  <span
    >@if(!isAutoLoadCheckedLocal()){disabled } @if(isAutoLoadCheckedLocal()){
    enabled}
  </span>
</mat-slide-toggle>
